/**
 * Translate the screens' file-list sort into what the server reads.
 *
 * The Media Manager, the adventure Files panel, event files and the chat image picker all ask for
 * `sortBy: 'name' | 'date' | 'size'` with `sortDesc`. The file list endpoints (`/api/me/files`,
 * `/api/adventures/{id}/files`, `/api/events/{id}/files`) read `sortBy` as one of
 * `CreatedDate | FileName | FileSize | DisplayName` and the direction as `sortDescending` — anything
 * else falls back to newest-first. So every sort the website ever offered was silently ignored.
 * Translated here, at the client, so the screens keep their own vocabulary.
 */

type ScreenSort = 'name' | 'date' | 'size'

const SERVER_FIELD: Record<ScreenSort, string> = {
  // The name shown is the display name, falling back to the file name — the server sorts the same.
  name: 'DisplayName',
  date: 'CreatedDate',
  size: 'FileSize',
}

export function toServerFileSort<T extends { sortBy?: ScreenSort; sortDesc?: boolean }>(
  params?: T
): (Omit<T, 'sortBy' | 'sortDesc'> & { sortBy?: string; sortDescending?: boolean }) | undefined {
  if (!params) return params
  const { sortBy, sortDesc, ...rest } = params
  return {
    ...rest,
    ...(sortBy ? { sortBy: SERVER_FIELD[sortBy] } : null),
    ...(sortDesc !== undefined ? { sortDescending: sortDesc } : null),
  }
}
